import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Welcome } from './pages/Welcome';
import { Chat } from './pages/Chat';
import { ShoppingList } from './pages/ShoppingList';
import { ProductDetail } from './pages/ProductDetail';
import { LanguageProvider } from './components/LanguageContext';
import { AssociateStatusProvider } from './components/AssociateStatusContext';
export function App() {
  return <LanguageProvider data-id="element-0">
      <AssociateStatusProvider data-id="element-1">
        <BrowserRouter data-id="element-2">
          <Routes data-id="element-3">
            <Route element={<Layout data-id="element-5" />} data-id="element-4">
              <Route path="/" element={<Welcome data-id="element-7" />} data-id="element-6" />
              <Route path="/chat" element={<Chat data-id="element-9" />} data-id="element-8" />
              <Route path="/list" element={<ShoppingList data-id="element-11" />} data-id="element-10" />
              <Route path="/product" element={<ProductDetail data-id="element-13" />} data-id="element-12" />
            </Route>
          </Routes>
        </BrowserRouter>
      </AssociateStatusProvider>
    </LanguageProvider>;
}